module.exports = __webpack_public_path__ + "img/logo-bg.1316f83d.png";